module.exports = __webpack_public_path__ + "static/media/gray-arrow-back.ce9d2a63.svg";